const styles = ({ BREAKPOINTS }) => ({
  container: {
    display: 'flex',
    marginBottom: '20px',
    [`@media (max-width: ${BREAKPOINTS.SM})`]: {
      flexWrap: 'wrap'
    }
  }
})

export default styles
